import React, { Fragment } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import BoxClassroom from './BoxClassroom/BoxClassroom';
import BoxStudent from './BoxStudent/BoxStudent';
import BoxPhoto from './BoxPhoto/BoxPhoto';

import './ContentBox.module.css';

const ContentBox = (props) => {
	const { type, droppableId } = props;

	let content = null;
	if (type === 'classroom') {
		content = (
			<BoxClassroom
				index={props.index}
				properties={props.properties}
				showTeacher={(id) => props.showTeacher(id)}
			/>
		);
	} else if (type === 'student') {
		content = (
			<BoxStudent
				showStudent={(id) => props.showStudent(id)}
				index={props.index}
				properties={props.properties}
			/>
		);
	} else if (type === 'photos') {
		content = (
			<BoxPhoto
				index={props.index}
				properties={props.properties}
			/>
		);
	}

	return (
		<Fragment>
			<Droppable droppableId={droppableId}>
				{(provided, snapshot) => (
					<div ref={provided.innerRef} className={snapshot.isDraggingOver ? 'isDraggedOver' : ''}>
						{content}
					</div>
				)}
			</Droppable>
		</Fragment>
	);
};

export default ContentBox;



// WEBPACK FOOTER //
// ./src/components/ContentBox/ContentBox.js